<section class="animated fadeIn welcome-component">

  <div class="welcome-component__container">

    <header class="welcome-component__header">
      <span class="subtitle">
        Get our <strong>farm essentials delivered regularly!</strong> These are our most popular and staple products,
        ensuring you always have fresh, locally sourced food on hand. This step is optional - <strong>you can subscribe
          now or skip and continue.</strong>
      </span>
    </header>

    <!-- Products -->
    <section class="welcome-component__products">

      @defer (on immediate; when products().size) {

      @for (item of products().entries(); track item[0]) {
      <div class="row my-3">
        <div class="col-12">
          <h3 class="category-name">
            {{item[1].category}}
          </h3>
        </div>
      </div>
      <div class="row">
        @for (product of item[1].products; track product.id) {
        @defer (on viewport; prefetch on immediate) {
        <div class="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12 animated fadeIn">
          <div class="product-card-grid__item">
            <app-product-card-v2 [isFromWelcome]="true" [cardResume]="{  settings: {}, productDetails:  product}">
            </app-product-card-v2>
          </div>
        </div>
        } @placeholder {
        <div class="col-xxl-3 col-lg-4 col-6  animated fadeInUp fadeIn mb-3">
          <div class="card position-relative border p-3 row-gap-3" aria-hidden="true">
            <span class="placeholder bg-secondary col-12"></span>
            <span class="placeholder bg-secondary col-6"></span>
            <span class="placeholder bg-secondary col-6"></span>
            <div class="placeholder bg-secondary col-12" style="height: 100px;"></div>
            <div class="card-body">
              <h5 class="card-title placeholder-glow">
                <span class="placeholder bg-secondary col-6"></span>
              </h5>
              <p class="card-text placeholder-glow">
                <span class="placeholder bg-secondary col-7"></span>
                <span class="placeholder bg-secondary col-4"></span>
                <span class="placeholder bg-secondary col-4"></span>
                <span class="placeholder bg-secondary col-6"></span>
                <span class="placeholder bg-secondary col-8"></span>
              </p>
              <a class="btn btn-secondary disabled placeholder col-12" aria-disabled="true"></a>
            </div>
          </div>
        </div>
        }
        }
      </div>
      }
      }

    </section>

    <!-- Buttons -->
    <footer class="welcome-component__buttons">

      <button type="button" class="btn btn-primary" (click)="finish()">
        Skip & Finish Registration
      </button>

    </footer>

  </div>

</section>